module.exports = __webpack_public_path__ + "site/img/8.640effa7.jpg";